class TPageTitle extends HTMLElement {
    static currentInstance = null;
    static originalTitle = document.title;

    constructor() {
        super();

        // Create shadow DOM
        const shadow = this.attachShadow({ mode: 'closed' });

        // Create style element
        const style = document.createElement('style');
        style.textContent = `
            :host {
                display: none;
            }
        `;

        // Create slot for content
        const slot = document.createElement('slot');

        // Add elements to shadow DOM
        shadow.appendChild(style);
        shadow.appendChild(slot);
    }

    connectedCallback() {
        // If there's an existing instance, disconnect it first
        if (TPageTitle.currentInstance && TPageTitle.currentInstance !== this) {
            TPageTitle.currentInstance.disconnectedCallback();
        }

        // Set this as the current instance
        TPageTitle.currentInstance = this;

        const content = this.textContent || this.innerHTML;
        if (content) {
            document.title = `${content} | ${TPageTitle.originalTitle}`;
        }
    }

    disconnectedCallback() {
        if (TPageTitle.currentInstance === this) {
            document.title = TPageTitle.originalTitle;
            TPageTitle.currentInstance = null;
        }
    }
}

customElements.define('t-page-title', TPageTitle);